import { useEffect, useRef, useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Lineup from "./components/Lineup";
import Location from "./components/Location";
import RichiestaStand from "./components/RichiestaStand";
import Footer from "./components/Footer";

export default function Home() {
  const audioRef = useRef<HTMLAudioElement>(null);
  const [muted, setMuted] = useState(false);
  const [playing, setPlaying] = useState(false);

  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;

    const tryPlay = () => {
      audio.play().then(() => {
        setPlaying(true);
      }).catch(() => {
        // autoplay blocked, will start on user interaction
      });
    };

    tryPlay();

    const handleInteraction = () => {
      if (!playing) {
        tryPlay();
      }
    };

    document.addEventListener("click", handleInteraction, { once: true });
    document.addEventListener("keydown", handleInteraction, { once: true });

    return () => {
      document.removeEventListener("click", handleInteraction);
      document.removeEventListener("keydown", handleInteraction);
    };
  }, [playing]);

  const toggleMute = (e: React.MouseEvent) => {
    e.stopPropagation();
    const audio = audioRef.current;
    if (!audio) return;

    if (!playing) {
      audio.play().then(() => setPlaying(true)).catch(() => {});
      setMuted(false);
    } else {
      const newMuted = !muted;
      audio.muted = newMuted;
      setMuted(newMuted);
    }
  };

  return (
    <main className="w-full min-h-screen" style={{ fontFamily: "'Londrina Solid', sans-serif" }}>
      <audio
        ref={audioRef}
        src="https://storage.readdy-site.link/project_files/3fa62b0e-d94c-44f3-afee-f1b918b70cb6/e733d9f7-2bda-4d27-a896-fef5ccc046eb_Audio_Tammorra.mp3?v=3d012c46167fcbf459f4281de730dca1"
        loop
        preload="auto"
      />

      {/* Floating audio control */}
      <button
        onClick={toggleMute}
        title={muted ? "Attiva audio" : "Silenzia audio"}
        className="fixed bottom-6 right-6 z-50 w-12 h-12 rounded-full flex items-center justify-center cursor-pointer transition-all duration-300 shadow-none"
        style={{ background: "rgba(0,0,0,0.65)", border: "2px solid rgba(255,255,255,0.25)" }}
      >
        {!playing || muted ? (
          <i className="ri-volume-mute-line text-white text-xl" />
        ) : (
          <i className="ri-volume-up-line text-white text-xl" style={{ animation: "pulse 1.5s infinite" }} />
        )}
      </button>

      <style>{`
        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.5; }
        }
      `}</style>

      <Navbar />
      <Hero />
      <Lineup />
      <Location />
      <RichiestaStand />
      <Footer />
    </main>
  );
}
